/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesStoreBank131PayWithSbpRequest
 */
export interface FxIdWebFeaturesStoreBank131PayWithSbpRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreBank131PayWithSbpRequest
     */
    PublicId: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesStoreBank131PayWithSbpRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreBank131PayWithSbpRequest(value: object): value is FxIdWebFeaturesStoreBank131PayWithSbpRequest {
    if (!('PublicId' in value) || value['PublicId'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesStoreBank131PayWithSbpRequestFromJSON(json: any): FxIdWebFeaturesStoreBank131PayWithSbpRequest {
    return FxIdWebFeaturesStoreBank131PayWithSbpRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreBank131PayWithSbpRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreBank131PayWithSbpRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'PublicId': json['PublicId'],
    };
}

export function FxIdWebFeaturesStoreBank131PayWithSbpRequestToJSON(json: any): FxIdWebFeaturesStoreBank131PayWithSbpRequest {
    return FxIdWebFeaturesStoreBank131PayWithSbpRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreBank131PayWithSbpRequestToJSONTyped(value?: FxIdWebFeaturesStoreBank131PayWithSbpRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'PublicId': value['PublicId'],
    };
}

